<template>
  <section class="regional">
    <div class="layout system-setting-layout" style="z-index: 11;">
      <div class="system-setting">
        <div class="layout-header regional-header" ref="searchBox">
          <div class="infor-layout-header">
            <span class="title">区域设置</span>
            <p>
              <el-button v-show="checkUserAuth(6, 100)" type="primary" size="small" @click="onAdd('添加区域', 'formAdd')" style="background-color: #3e7878;border-color: #3e7878">添加区域</el-button>
              <el-button size="small" @click="onMerge('合并成复合区', 'mergeArea')">勾选合并</el-button>
            </p>
          </div>
        </div>
        <div style="height:5rem;"></div>
        <div class="regional_table">
          <el-table
            v-show="checkUserAuth(6, 99)"
            v-loading.body="tableLoading"
            class="table_content"
            :max-height="tableViewHeight"
            :data="tableData"
            style="width: 100%;margin-bottom: 1.25rem;"
            row-key="id"
            :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
            :header-cell-class-name="cellClass"
            @selection-change="onSelectionChange"
            @row-click="onRowClick">
            <el-table-column
              :selectable="selectable"
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="areaName"
              label="区域名称"
              width="250">
            </el-table-column>
            <el-table-column
              prop="level"
              label="区域等级"
              width="250">
              <template v-slot:default="props">
                <span>{{getLevel(props.row.level)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              label="区域代码">
            </el-table-column>
            <el-table-column
              prop="platformCode"
              label="站点代码">
            </el-table-column>
            <el-table-column
              label="监管平台是否显示">
              <template v-slot:default="props">
                <el-switch v-model="props.row.monitorOpen" @change="onSwitchChange(props.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              label="觅单车是否显示">
              <template v-slot:default="props">
                <el-switch :disabled="!props.row.monitorOpen" v-model="props.row.isOpen" @change="onSwitchChangeMi(props.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="180">
              <template v-slot:default="scope">
                <div v-if="scope.row.level>=2" class="right el-button-box">
                  <div style="display: flex; flex-wrap: wrap;">
                    <div style="display: flex; width: 100%; margin-bottom: 5px;">
                      <el-button
                        style="padding:0; flex: 1;"
                        v-show="checkUserAuth(6, 103)"
                        v-if="scope.row.aggregation === 0"
                        class="btn-text"
                        @click="onClick(scope.row, 'painting')"
                        type="text"
                        size="small">
                        围栏绘制
                      </el-button>
                      <el-button
                        style="padding:0; flex: 1;"
                        v-show="checkUserAuth(6, 105)"
                        v-if="scope.row.aggregation === 0"
                        class="btn-text"
                        @click="onClick(scope.row, 'paintingEdit')"
                        type="text"
                        size="small">
                        修改围栏
                      </el-button>
                    </div>
                    <div style="display: flex; width: 100%;margin-top: 2px;">
                      <el-button
                        style="padding:0; flex: 1;"
                        v-show="checkUserAuth(6, 101)"
                        v-if="scope.row.aggregation === 0"
                        class="btn-text"
                        @click="onEdit('edit', scope.row)"
                        type="text"
                        size="small">
                        修改区域
                      </el-button>
                      <el-button
                        style="padding:0; flex: 1;"
                        v-show="checkUserAuth(6, 102)"
                        v-if="scope.row.aggregation === 0"
                        class="btn-text"
                        @click="onDel('del', scope.row)"
                        type="text"
                        size="small">
                        删除区域
                      </el-button>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-show="!checkUserAuth(6, 99)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
    <!-- 一级弹窗 -->
    <w-dialog
      width="50%"
      ref="w-dialog"
      :title="dialogTitle"
      :sureBtnText="sureBtnText"
      @handleCloseRight="onRightClose"
      @handleClose="onClose"
      @onSure="onSure">
      <template v-slot:content>
        <div v-if="['formAdd', 'edit'].includes(type)">
          <el-form ref="formAdd" :rules="formAddRules" :model="formAdd" label-width="5rem">
            <template v-if="type === 'formAdd'">
              <el-form-item label="选择省份" prop="level">
                <el-cascader
                  size="small"
                  class="w250"
                  :props="addressCascader"
                  v-model="formAdd.level"
                  :options="nationAddress"
                  @change="onAddressChange"/>
              </el-form-item>
            </template>
            <el-form-item label="区域名称" prop="areaName">
              <el-input size="small" v-model="formAdd.areaName" placeholder="请输入区域名称" class="w250"></el-input>
            </el-form-item>
            <el-form-item label="区域代码" prop="id">
              <template v-if="type === 'formAdd'">
                <span class="nums" v-if="formAdd.level && formAdd.level.length">{{formAdd.level[formAdd.level.length - 1].slice(0, 4)}}</span>
              </template>
              <template v-if="type === 'edit'">
                <span class="nums" v-if="editData.id">{{editData.id.slice(0, 4)}}</span>
              </template>
              <el-input size="small" :disabled="type === 'edit'" v-model="formAdd.id" placeholder="请输入区域代码" class="w250 el-input-45"></el-input>
              <span class="tips">6位数字</span>
            </el-form-item>
            <el-form-item label="站点代码" prop="platformCode">
              <template v-if="type === 'formAdd'">
                <span class="nums" v-if="currItem && currItem.platformCode">{{currItem.platformCode.slice(0, 6)}}</span>
              </template>
              <template v-if="type === 'edit'">
                <span class="nums" v-if="editData.platformCode">{{editData.platformCode.slice(0, 6)}}</span>
              </template>
              <el-input size="small" v-model="formAdd.platformCode" placeholder="请输入站点编号" class="w250 el-input-62"></el-input>
              <span class="tips">8位数字</span>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="['mergeArea'].includes(type)">
          <el-form ref="mergeArea" :rules="mergeAreaRules" :model="mergeArea" label-width="5rem">
            <el-form-item label="区域名称" prop="areaName">
              <el-input size="small" v-model="mergeArea.areaName" placeholder="请输入区域名称" class="w250"></el-input>
            </el-form-item>
            <el-form-item label="区域代码" prop="id">
              <el-input size="small" v-model="mergeArea.id" placeholder="请输入区域代码" class="w250"></el-input>
              <span class="tips">6位数字</span>
            </el-form-item>
            <el-form-item label="站点编号" prop="platformCode">
              <el-input size="small" v-model="mergeArea.platformCode" placeholder="请输入站点编号" class="w250"></el-input>
              <span class="tips">8位数字</span>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="['del'].includes(type)">
          <p>你是否确定移除“{{editData.areaName}}”？</p>
        </div>
        <div v-if="['setRail'].includes(type)">
          <p v-if="['painting'].includes(typeStyle)">你是否确定放弃本次区域围栏绘制？</p>
          <p v-if="['paintingEdit'].includes(typeStyle)">你是否确定放弃本次区域围栏编辑？</p>
          <p v-if="typeStyle === 'noEntryFence'">你是否确定放弃本次禁行区围栏绘制？</p>
        </div>
      </template>
    </w-dialog>
    <!-- 围栏绘制 -->
    <div v-if="showPainting" class="layout" style="margin-left: 0rem;z-index: 11;">
      <div class="system-setting">
        <div id="paintContainer" style="width: 100%;height: 95%"></div>
        <div id="toolControl" class="map_handle_box_device" v-if="['paintingEdit', 'paintingEdit', 'delete'].includes(typeStyle)">
          <div class="title">修改围栏</div>
          <div class="map_handles">
            <div class="map_handle" @click="onEditor('delete')">删除图形</div>
            <div class="map_handle" @click="onEditor('union')">合并图形</div>
          </div>
        </div>
        <div class="fixed-bottom">
          <div class="flex-center">
            <el-button @click="onSavePaint" size="small" type="primary">保存</el-button>
            <el-button @click="onCancelPaintPre('setRail')" size="small">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from '@/api'
import WDialog from '@/components/Model/index.vue'
import { mapGetters } from 'vuex'
import store from '../../../store'
var AMap = window.AMap
export default {
  name: 'regional',
  data() {
    return {
      tableViewHeight: 0,
      dialogTitle: '',
      type: '',
      tableLoading: false,
      areaLists: [],
      tableData: [],
      // 添加区域
      formAdd: {
        level: '',
        areaName: '',
        id: '',
        platformCode: ''
      },
      sureBtnText: '',
      // 编辑区域
      editData: null,
      formAddRules: {
        level: [
          { required: true, message: '请选择等级', trigger: 'blur' }
        ],
        areaName: [
          { required: true, message: '请填写区域名称', trigger: 'blur' }
        ],
        id: [
          { required: true, message: '请填写区域代码', trigger: 'blur' },
          { min: 2, max: 2, message: '区域代码必须6位', trigger: 'blur' },
          { validator: this.validateId.bind(this), trigger: 'blur' }
        ],
        platformCode: [
          { required: true, message: '请填写站点编号', trigger: 'blur' },
          { min: 2, max: 2, message: '站点编号必须8位', trigger: 'blur' },
          { validator: this.validatePlatformCode.bind(this), trigger: 'blur' }
        ]
      },
      // 合并区域
      mergeArea: {
        areaName: '',
        id: '',
        platformCode: ''
      },
      mergeAreaRules: {
        areaName: [
          { required: true, message: '请填写区域名称', trigger: 'blur' }
        ],
        id: [
          { required: true, message: '请填写区域代码', trigger: 'blur' },
          { min: 6, max: 6, message: '区域代码必须6位', trigger: 'blur' }
        ],
        platformCode: [
          { required: true, message: '请填写站点编号', trigger: 'blur' },
          { min: 8, max: 8, message: '站点编号必须8位', trigger: 'blur' }
        ]
      },
      nationAddress: {},
      addressCascader: {
        value: 'id',
        label: 'areaName'
      },
      multipleSelection: [],
      originAreaData: [], // 只保存每次的原始数据
      // 围栏绘制相关
      showPainting: false,
      map: undefined,
      editor: [], // 统一管理所有editor实例
      qqKey: '64MBZ-DV56Z-W6RXX-74H5R-XHQI7-UUB2T',
      drawType: 'draw',
      activeOverlayId: 'draw',
      geometryList: [], // 绘制的图形列表集合
      geometries: [], // 绘制已绘制的图形
      polygons: [], // 清空绘制的围栏
      editGeometriesId: null,
      typeStyle: null,
      geometriesSelectList: [], // 保存参与合并的图形的集合
      locationByAreaName: '',
      currItem: null,
      activeEditor: null, // 当前激活的编辑器
      // 记录当前选中多边形的索引
      selectedPolygonIndex: []
    }
  },
  computed: {
    ...mapGetters([
      'nationalArea',
      'user',
      'selfAreaId',
      'permissions',
      'globaleSelfAreaId',
      'userLevel']),
    apiDefaultParams() {
      return { selfAreaId: this.selfAreaId }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onClickDel() {
      const vm = this
      const params = {
        ...vm.apiDefaultParams,
        id: 17
      }
      Api.delRail(params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域围栏删除成功！')
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('删除区域围栏报错：', err)
        })
    },
    // 校验相关
    validateId(rule, value, callback) {
      if (this.type === 'formAdd' && (!this.formAdd.level || this.formAdd.level.length === 0)) {
        callback(new Error('请选择省份'))
      }
      console.log(this.formAdd.id, value)
      // callback(new Error('请输入合法的登录账号'))
      // todo api
      callback()
    },
    validatePlatformCode(rule, value, callback) {
      if (this.type === 'formAdd' && (!this.formAdd.level || this.formAdd.level.length === 0)) {
        callback(new Error('请选择省份'))
      }
      let platformCode
      // 新增站点代码
      if (this.type === 'formAdd') {
        platformCode = this.currItem.platformCode.slice(0, 6)
      } else {
        // 编辑站点代码
        platformCode = this.editData.platformCode.slice(0, 6)
        const originalValue = this.editData.platformCode
        const newValue = platformCode + value
        // 如果值没有变化，直接通过校验
        if (newValue === originalValue) {
          callback()
          return
        }
      }
      const params = {
        selfAreaId: this.selfAreaId,
        platformCode: platformCode + value
      }
      Api.getAreaPlatformCodeByCount(params)
        .then(res => {
          if (res.code === 200) {
            if (res.data.existPlatformCode === true) {
              callback(new Error('该站点代码已被注册，请重新输入！'))
            } else {
              callback()
            }
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    // 图形绘制相关
    async onSavePaint() {
      if (this.editGeometriesId) {
        // 编辑
        if (this.typeStyle === 'noEntryFence') {
          await this.editEntryRail()
        } else if (['paintingEdit', 'painting'].includes(this.typeStyle)) {
          await this.editRail()
        }
      } else {
        // 新增
        if (this.typeStyle === 'noEntryFence') {
          await this.setEntryRail()
        } else if (this.typeStyle === 'painting') {
          await this.setRail()
        }
      }
    },
    editEntryRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          id: vm.editGeometriesId,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : JSON.stringify([])
        }
        Api.editEntryRail(params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('禁行区围栏修改成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          }).catch(err => {
            console.log('修改禁行区围栏报错：', err)
            reject(err)
          })
      })
    },
    editRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          id: vm.editGeometriesId,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : ''
        }
        Api.editRail(params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('区域围栏修改成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('修改区域围栏报错：', err)
            reject(err)
          })
      })
    },
    setEntryRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams
        }
        const data = {
          areaId: vm.editData.id,
          selectAreaId: vm.editData.id,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : JSON.stringify([])
        }
        Api.setEntryRail(data, params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('禁行区围栏绘制成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          }).catch(err => {
            console.log('创建禁行区围栏报错：', err)
            reject(err)
          })
      })
    },
    setRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams
        }
        const data = {
          areaId: vm.editData.id,
          selectAreaId: vm.editData.id,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : JSON.stringify([])
        }
        Api.setRail(data, params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('区域围栏绘制成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('创建区域围栏报错：', err)
            reject(err)
          })
      })
    },
    onCancelPaintPre(type) {
      this.dialogTitle = '温馨提示'
      this.sureBtnText = '确定'
      this.type = type
      this.$refs['w-dialog'].onShowDialog()
    },
    onCancelPaint() {
      this.typeStyle = null
      this.editGeometriesId = null
      this.geometries = []
      this.geometryList = []
      this.editData = null
      this.drawType = 'draw'
      this.showPainting = false
      this.activeOverlayId = 'draw'
      this.onClose()
    },
    onEditor(type) {
      this.drawType = type
      if (['draw'].includes(type)) {
        this.activeOverlayId = 'draw'
      } else {
        if (type === 'delete') {
          this.deleteSelectedPolygon() // 调用删除方法
        } else if (type === 'union') {
          this.mergePolygons()
        }
      }
    },
    getRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          areaId: row.id,
          selectAreaId: row.id
        }
        Api.getRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    getEntryRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          areaId: row.id,
          selectAreaId: row.id
        }
        Api.getEntryRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          }).catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    async onClick(row, type) {
      const vm = this
      vm.typeStyle = type
      let res
      if (type === 'painting') {
        // 区域围栏 - 绘制
        if (vm.checkUserAuth(6, 109)) {
          res = await vm.getRail(row)
        }
        vm.drawType = 'draw'
      } else if (type === 'paintingEdit') {
        // 区域围栏 - 编辑
        if (vm.checkUserAuth(6, 109)) {
          res = await vm.getRail(row)
        }
        vm.drawType = 'edit'
      } else if (type === 'noEntryFence') {
        // 禁行区
        res = await vm.getEntryRail(row)
      }
      if (res && res.code && res.data && res.data.length) {
        vm.geometries = []
        vm.geometryList = []
        res.data.forEach(item => {
          if (item.gpsRally && JSON.parse(item.gpsRally) && JSON.parse(item.gpsRally)[0] && JSON.parse(item.gpsRally)[0].id) {
            vm.editGeometriesId = item.id
            const gpsRally = JSON.parse(item.gpsRally)
            gpsRally.forEach(pgs => {
              const length = pgs.paths && pgs.paths.length
              if (length) {
                let paths = []
                // 腾讯转换为高德坐标格式
                paths = pgs.paths.map(point => [point.lng, point.lat])
                vm.geometries.push(paths)
                vm.geometryList.push(pgs)
              }
            })
          }
        })
      }
      vm.editData = row
      vm.showPainting = true
      vm.locationByAreaName = await vm.getLocationByAreaName(row)
      vm.$nextTick(vm.initMap.bind(vm, vm.locationByAreaName))
    },
    initMap(location) {
      const vm = this
      if (!location || !location.lng || !location.lat) {
        vm.$message.error('地址解析发生错误！')
        return
      }
      // 初始化地图
      if (vm.map) {
        vm.map.destroy()
      }
      this.map = new AMap.Map('paintContainer', {
        viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D'
        zoom: 12, // 初始化地图层级
        center: [location.lng, location.lat]// 初始化地图中心点
      })
      this.map.on('complete', () => {
        console.log('地图瓦片加载完成')
      })

      // 监听加载失败事件
      this.map.on('error', (e) => {
        console.error('地图加载失败:', e)
      })
      // 创建现有多边形
      if (vm.geometries.length) {
        vm.polygons = vm.geometries.map(path => {
          return new AMap.Polygon({
            path: path,
            strokeColor: '#4885fb',
            strokeWeight: 2,
            fillColor: 'rgba(125,194,245,0.2)',
            // fillOpacity多边形填充透明度,取值范围 [0,1],0表示完全透明,1表示不透明
            fillOpacity: 0.2
          })
        })
        vm.map.add(vm.polygons)
      }
      // 初始化绘制/编辑工具
      if (vm.drawType === 'draw') {
        // 绘制模式
        var mouseTool = new AMap.MouseTool(vm.map)
        mouseTool.polygon({
          strokeColor: '#4885fb',
          fillColor: 'rgba(125,194,245,0.2)',
          fillOpacity: 0.2
        })
        // 监听绘制完成事件
        mouseTool.on('draw', ({ obj }) => {
          const path = obj.getPath().map(point => ({ lng: point.lng, lat: point.lat }))
          console.log('图形绘制完成', obj)
          vm.geometries.push({
            id: Date.now(),
            paths: path
          })
          vm.geometryList.push({
            id: Date.now(),
            paths: path
          })
          vm.polygons.push(obj)
          mouseTool.close()
        })
      } else if (vm.drawType === 'edit' || vm.drawType === 'union') {
        // 编辑模式或者合并图形
        // 初始化编辑器
        vm.editor = vm.polygons.map(poly => {
          const editor = new AMap.PolygonEditor(vm.map, poly)
          editor.close()
          // 新增：选中事件监听
          editor.on('select', (event) => {
            vm.geometriesSelectList = event.target
          })
          // 添加点击事件：激活当前编辑器
          poly.on('click', () => {
            // 关闭之前激活的编辑器
            // 双击激活的当前多边形编辑图形
            editor.open()
            this.activeEditor = editor
            vm.selectedPolygonIndex.push(vm.polygons.findIndex(p => p === poly))
          })
          // 双击关闭激活的当前多边形编辑图形
          poly.on('dblclick', (e) => {
            const index = vm.polygons.findIndex(p => p === poly)
            const uniqueArr = [...new Set(vm.selectedPolygonIndex)]
            vm.selectedPolygonIndex = uniqueArr.filter(item => item !== index)
            this.activeEditor.close()
            this.activeEditor = null
          })
          // 监听编辑事件
          editor.on('adjust', ({ target }) => {
            const index = vm.polygons.findIndex(p => p === target)
            if (index > -1) {
              const newPath = target.getPath().map(point => ({ lng: point.lng, lat: point.lat }))
              vm.geometries.splice(index, 1, newPath)
              let geometryObj = {}
              geometryObj = {
                id: Date.now(),
                paths: newPath
              }
              vm.geometryList.splice(index, 1, geometryObj)
              console.log('图形编辑完成', vm.geometryList)
            }
          })
          editor.on('addnode', ({ target }) => {
            const index = vm.polygons.findIndex(p => p === target)
            if (index > -1) {
              vm.geometries[index] = target.getPath().map(({ lng, lat }) => [lng, lat])
            }
          })
          editor.on('removenode', ({ target }) => {
            const index = vm.polygons.findIndex(p => p === target)
            if (index > -1) {
              vm.geometryList.splice(index, 1)
              vm.geometries.splice(index, 1)
            }
          })
          return editor
        })
      }
    },
    // 删除图形
    deleteSelectedPolygon() {
      if (this.selectedPolygonIndex.length === 0) {
        this.$message.warning('请先选择要删除的图形')
        return
      }
      // 按索引降序排序（避免删除时索引变化导致错误）
      const sortedIndexes = [...this.selectedPolygonIndex].sort((a, b) => b - a)
      sortedIndexes.forEach(index => {
        // 1. 关闭编辑器
        if (this.editor[index]) {
          this.editor[index].close()
        }
        // 2. 从地图移除多边形
        if (this.polygons[index]) {
          this.map.remove(this.polygons[index])
        }
        // 3. 从所有数据结构中移除
        this.polygons.splice(index, 1)
        this.geometries.splice(index, 1)
        this.geometryList.splice(index, 1)
        // 移除编辑器引用
        this.editor.splice(index, 1)
      })
      // 4. 清理选中状态
      this.selectedPolygonIndex = []
      this.activeEditor = null
    },
    // 合并选中的多边形
    mergePolygons() {
      const vm = this
      if (vm.selectedPolygonIndex.length < 2) {
        vm.$message.warning('请至少选中两个多边形进行合并')
        return
      }
      // 获取选中的多边形对象
      const selectedPolygons = vm.selectedPolygonIndex.map(index => vm.polygons[index])
      // 检查多边形是否相交
      const isIntersecting = this.checkPolygonsIntersect(selectedPolygons)
      if (!isIntersecting) {
        vm.$message.warning('选中的多边形必须相交才能合并')
        return
      }
      // 执行合并
      const mergedPolygon = vm.mergePolygonsTwo(selectedPolygons)
      if (!mergedPolygon) return
      const sortedIndexes = [...this.selectedPolygonIndex].sort((a, b) => b - a)
      sortedIndexes.forEach(index => {
        //  从所有数据结构中移除
        vm.polygons.splice(index, 1)
        vm.geometryList.splice(index, 1)
        vm.geometries.splice(index, 1)
      })
      // 删除旧多边形，添加新多边形
      vm.map.remove(selectedPolygons)
      vm.polygons.push(mergedPolygon)
      vm.map.add(vm.polygons)
      // 更新 geometries 数据
      const geometriesPaths = mergedPolygon.getPath().map(p => ([p.lng, p.lat]))
      const paths = mergedPolygon.getPath().map(p => ({ lng: p.lng, lat: p.lat }))
      vm.geometries.push(geometriesPaths)
      vm.geometryList.push({
        id: Date.now(),
        paths: paths
      })
      const sortedIndexes1 = [...this.selectedPolygonIndex].sort((a, b) => b - a)
      sortedIndexes1.forEach(index => {
        // 1. 关闭编辑器
        if (this.editor[index]) {
          this.editor[index].close()
        }
      })
      // 重置选中状态
      vm.selectedPolygonIndex = []
      vm.initMap(vm.locationByAreaName)
    },
    // 检查多边形是否相交
    checkPolygonsIntersect(polygons) {
      for (let i = 0; i < polygons.length; i++) {
        for (let j = i + 1; j < polygons.length; j++) {
          if (!AMap.GeometryUtil.doesRingRingIntersect(
            polygons[i].getPath(),
            polygons[j].getPath()
          )) {
            return false
          }
        }
      }
      return true
    },
    // 合并多个多边形
    mergePolygonsTwo(polygons) {
      // 收集所有边界点
      const allPoints = polygons.flatMap(poly => poly.getPath())
      // 过滤掉在任意多边形内部的点
      const boundaryPoints = allPoints.filter(point => {
        return !polygons.some(poly => {
          const path = poly.getPath()
          // 跳过当前多边形自身
          if (path.includes(point)) return false
          return AMap.GeometryUtil.isPointInRing(point, path)
        })
      })
      // 计算合并后的多边形路径
      const mergedPath = this.calculateConvexHull(boundaryPoints)
      return new AMap.Polygon({
        path: mergedPath,
        strokeColor: '#4885fb',
        strokeWeight: 2,
        fillColor: 'rgba(125,194,245,0.2)',
        fillOpacity: 0.2
      })
    },
    // 计算凸包（简单实现）
    calculateConvexHull(points) {
      if (points.length < 3) return points
      // 找到左下角的点作为基准
      const pivot = points.reduce((min, p) =>
        (p.lat < min.lat || (p.lat === min.lat && p.lng < min.lng)) ? p : min
      )
      // 按极角排序
      const sorted = [...points].sort((a, b) => {
        const angleA = Math.atan2(a.lat - pivot.lat, a.lng - pivot.lng)
        const angleB = Math.atan2(b.lat - pivot.lat, b.lng - pivot.lng)
        return angleA - angleB
      })
      // 使用栈计算凸包
      const stack = [sorted[0], sorted[1]]
      for (let i = 2; i < sorted.length; i++) {
        while (stack.length >= 2) {
          const top = stack[stack.length - 1]
          const next = stack[stack.length - 2]
          if (this.crossProduct(next, top, sorted[i]) <= 0) {
            stack.pop()
          } else {
            break
          }
        }
        stack.push(sorted[i])
      }
      return stack
    },
    // 计算叉积
    crossProduct(o, a, b) {
      return (a.lng - o.lng) * (b.lat - o.lat) - (a.lat - o.lat) * (b.lng - o.lng)
    },
    // 事件处理区
    onSelectionChange(val) {
      this.multipleSelection = val
    },
    onRowClick(row, column, event) {
      this.getArea(row)
    },
    onAdd(title, type) {
      const vm = this
      // 获取地址
      vm.nationAddress = vm.delAddressInLevel2(vm.nationalArea)
      vm.nationAddress = vm.listToTree(vm.nationAddress)
      vm.nationAddress = vm.changeAddress(vm.nationAddress)
      vm.dialogTitle = title
      vm.sureBtnText = '添加'
      vm.type = type
      vm.$refs['w-dialog'].onShowDialog()
    },
    onEdit(type, row) {
      const vm = this
      vm.editData = row
      vm.dialogTitle = '修改区域'
      vm.sureBtnText = '保存'
      vm.type = type
      vm.formAdd.id = row.id.slice(row.id.length - 2, row.id.length)
      vm.formAdd.areaName = row.areaName
      vm.formAdd.platformCode = row.platformCode.slice(row.platformCode.length - 2, row.platformCode.length)
      vm.$refs['w-dialog'].onShowDialog()
    },
    onDel(type, row) {
      const vm = this
      vm.editData = row
      vm.dialogTitle = '温馨提示'
      vm.sureBtnText = '确定'
      vm.type = type
      vm.$refs['w-dialog'].onShowDialog()
    },
    onMerge(title, type) {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择需要合并的区域！')
        return
      }
      const parentId = this.multipleSelection[0].parentId
      const isAgree = this.multipleSelection.every(item => item.parentId === parentId)
      if (!isAgree) {
        this.$message.warning('当前所选区域不可合并，请重新选择！')
        return
      }
      this.dialogTitle = title
      this.sureBtnText = '合并'
      this.type = type
      this.$refs['w-dialog'].onShowDialog()
    },
    getLocationByAreaName(row) {
      const parent = this.areaLists.filter(item => item.id === row.parentId)
      let areaName = row.areaName
      if (parent && parent.length && parent[0]) {
        areaName = parent[0].areaName + areaName
      }
      return new Promise((resolve, reject) => {
        AMap.plugin('AMap.Geocoder', function() {
          var geocoder = new AMap.Geocoder()
          geocoder.getLocation(areaName, function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              // 经纬度
              var lng = result.geocodes[0].location.lng
              var lat = result.geocodes[0].location.lat
              resolve({ lng, lat })
            } else {
              console.log('定位失败！')
              reject(new Error('getLocationByAreaName: 定位失败！'))
            }
          })
        })
      })
    },
    getDistrictChildren(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          id: row.id, // 父级行政区划ID（adcode）
          max_offset: row.level >= 2 ? '500' : '3000',
          key: vm.qqKey
        }
        Api.getDistrictChildren(params)
          .then(res => {
            console.log(res)
            resolve(res)
          }).catch(err => {
            console.log('腾讯地图获取行政区划api报错：', err)
            reject(err)
          })
      })
    },
    onCommand(type, row) {
      if (type === 'edit') {
        this.onEdit(type, row)
      } else if (type === 'del') {
        this.onDel(type, row)
      } else if (type === 'noEntryFence') {
        this.onClick(row, type)
      } else if (type === 'paintingEdit') {
        this.onClick(row, type)
      } else {
        console.log('onCommand')
      }
    },
    setMonitorOpenByRecursion(row, list = []) {
      if (!row || (row && !row.id)) {
        return null
      }
      if (list && !list.length) {
        return null
      }
      for (let i = 0, l = list.length; i < l; i++) {
        const item = list[i]
        if (item.id && item.id === row.id) {
          item.monitorOpen = row.monitorOpen ? 1 : 0
          item.isOpen = row.isOpen ? 1 : 0
          return null
        } else if (item.child && item.child.length) {
          this.setMonitorOpenByRecursion(row, item.child)
        }
      }
    },
    fetchEditArea(data) {
      // 获取初始化地址
      const vm = this
      vm.tableLoading = true
      return new Promise((resolve, reject) => {
        Api.editArea(data, vm.apiDefaultParams)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('操作成功！')
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
            vm.tableLoading = false
          })
          .catch(err => {
            vm.tableLoading = false
            reject(err)
            console.log(err)
          })
      })
    },
    // 显示功能
    getListAddress(row, arrs) {
      arrs.push(row)
      if (row.aggregation === 0 && row.aggregationId) {
        // 复合区
        const aggregation = this.areaLists.find(item => item.id === row.aggregationId)
        return this.getListAddress(aggregation, arrs)
      } else if (row.parentId) {
        const parent = this.areaLists.find(item => item.id === row.parentId)
        return this.getListAddress(parent, arrs)
      } else {
        return arrs
      }
    },
    checkParent(row) {
      const list = this.getListAddress(row, [])
      let res = true
      for (let i = 1, l = list.length; i < l; i++) {
        const item = list[i]
        if (!item.monitorOpen) {
          res = false
          break
        }
      }
      return res
    },
    checkParentMi(row) {
      const list = this.getListAddress(row, [])
      let res = true
      for (let i = 1, l = list.length; i < l; i++) {
        const item = list[i]
        if (!item.isOpen) {
          res = false
          break
        }
      }
      return res
    },
    checkAllChildren(originCurr, arr) {
      if (originCurr.child) {
        for (let i = 0, l = originCurr.child.length; i < l; i++) {
          const item = originCurr.child[i]
          arr.push(item.areaName)
          if (item.child) {
            return this.checkAllChildren(item, arr)
          }
        }
      } else {
        arr.push(originCurr.areaName)
      }
      return arr
    },
    checkChild(row) {
      let res = true
      if (row.child) {
        res = row.child.every(item => !item.monitorOpen)
      }
      return res
    },
    checkChildMi(row) {
      let res = true
      if (row.child) {
        res = row.child.every(item => !item.isOpen)
      }
      return res
    },
    // 监管平台是否显示
    async onSwitchChange(row) {
      console.log(row)
      const vm = this
      if (Number(vm.user.areaLevel) >= row.level && vm.user.areaId !== row.id && vm.user.areaId !== '000000') {
        vm.$message.error('权限不足，无法关闭')
        row.monitorOpen = !row.monitorOpen
        return
      }
      // 检查上级s
      if (!this.checkParent(row)) {
        vm.$message.error('请先开通上一级地区')
        row.monitorOpen = !row.monitorOpen
        return
      }
      // 检查下级s
      if (!row.monitorOpen && row.child && !this.checkChild(row)) {
        vm.$message.error('请先关闭下一级地区')
        row.monitorOpen = !row.monitorOpen
        return
      }
      const data = JSON.parse(JSON.stringify(row))
      data.monitorOpen = data.monitorOpen ? 1 : 0
      if (data.monitorOpen === 0) {
        data.isOpen = 0
        row.isOpen = false
      } else {
        data.isOpen = data.isOpen ? 1 : 0
      }
      await vm.fetchEditArea(data)
      // 不刷新
      // vm.init()
      vm.refreshAddress()
    },
    // 觅单车是否显示
    async onSwitchChangeMi(row) {
      console.log('onSwitchChangeMi', row)
      const vm = this
      if (Number(vm.user.areaLevel) >= row.level && vm.user.areaId !== row.id && vm.user.areaId !== '000000') {
        vm.$message.error('权限不足，无法关闭')
        row.isOpen = !row.isOpen
        return
      }
      if (!this.checkParentMi(row)) {
        vm.$message.error('请先开通上一级地区')
        row.isOpen = !row.isOpen
        return
      }
      // 检查下级s
      if (!row.isOpen && row.child && !this.checkChildMi(row)) {
        vm.$message.error('请先关闭下一级地区')
        row.isOpen = !row.isOpen
        return
      }
      const data = JSON.parse(JSON.stringify(row))
      data.isOpen = data.isOpen ? 1 : 0
      data.monitorOpen = data.monitorOpen ? 1 : 0
      console.log(data, 223333)
      await vm.fetchEditArea(data)
      // 不刷新
      // vm.init()
      vm.refreshAddress()
    },
    onAddressChange(value) {
      console.log(value)
      if (value && value.length) {
        this.currItem = this.nationalArea.find(item => item.id === value[value.length - 1])
      }
    },
    // 弹窗处理
    onRightClose() {
      this.onClose()
    },
    onClose() {
      this.$refs['w-dialog'].onCloseDialog()
      this.clearFormDate()
    },
    clearFormDate() {
      if (['formAdd', 'edit'].includes(this.type)) {
        this.formAdd.level = ''
        this.formAdd.areaName = ''
        this.formAdd.id = ''
        this.formAdd.platformCode = ''
      } else if (this.type === 'mergeArea') {
        this.mergeArea.areaName = ''
        this.mergeArea.id = ''
        this.mergeArea.platformCode = ''
      } else if (this.type === 'setRail') {
        return null
      }
      this.currItem = null
      this.editData = null
      this.dialogTitle = ''
      this.sureBtnText = ''
      this.type = ''
    },
    onSure() {
      if (this.type === 'formAdd') {
        // 添加区域
        this.handleAdd()
      } else if (this.type === 'edit') {
        // 编辑区域
        this.handleEdit()
      } else if (this.type === 'del') {
        // 删除
        this.handleDel()
      } else if (this.type === 'mergeArea') {
        // 合并区域
        this.handleMergeArea()
      } else if (this.type === 'setRail') {
        this.onCancelPaint()
      }
    },
    // 数据处理
    findByOwn(data, map, mapkey) {
      // 深度检索当前地址对应的 地区
      // 返回检索到的目标地址
      for (let i = 0, l = data.length; i < l; i++) {
        const item = data[i]
        if (item.id === mapkey) {
          return item
        } else if (item.child && item.child.length) {
          const current = this.findByOwn(item.child, map, mapkey)
          if (current) {
            return current
          }
        }
      }
    },
    translateTableData(data, map, mapkey) {
      // 依赖 findByOwn
      // 收集当前table全量地址，转化这些数据到可以展示到table中
      // 返回tableData
      let temp
      if ((!data || data.length === 0) && (!map || map.length === 0)) {
        temp = []
      } else if (data && data.length && map && map.length && mapkey) {
        const current = this.findByOwn(data, map, mapkey)
        current.child = []
        current.child = map
        temp = data
      } else if (data && data.length) {
        temp = data
      } else {
        temp = map
      }
      if (!map && !mapkey) {
        // 初始化的时候整理数据
        temp.forEach(item => {
          item.monitorOpen = !!item.monitorOpen
          item.isOpen = !!item.isOpen
          if (item.child) {
            item.child = []
          }
          if (item.child && item.child.length) {
            return this.translateTableData(item.child)
          }
        })
      }
      return temp
    },
    filterAddress(list, address) {
      // 返回当前 区域下面的 子集
      if (!list || list.length === 0) {
        return []
      }
      // tableData 的逻辑
      if (!address || !address.id) {
        if (this.selfAreaId === '000000') {
          return list.filter(item => item.level === 0)
        } else {
          return list.filter(item => (item.level === 0 && (this.selfAreaId.slice(0, 2) + '0000') === item.id))
        }
      }
      const newLists = list.filter(item => {
        if (item.aggregation === 0 && item.aggregationId) {
          // 处理复合区
          return item.aggregationId === address.id
        } else {
          // 普通实体区
          return item.parentId === address.id
        }
      })
      return newLists
    },
    init() {
      // 获取初始化地址
      const vm = this
      vm.tableLoading = true
      return new Promise((resolve, reject) => {
        Api.regionalArea(vm.apiDefaultParams)
          .then(res => {
            if (res.code === 200) {
              vm.originAreaData = res.data
              vm.areaLists = vm.translateTableData(vm.treeToList(res.data))
              vm.tableData = vm.filterAddress(vm.areaLists, '')
            } else {
              vm.$message.warning(res.message)
            }
            vm.calcView()
            vm.tableLoading = false
          })
          .catch(err => {
            vm.tableLoading = false
            console.log(err)
          })
      })
    },
    getArea(address) {
      // 获取当前点击的地址集合
      const vm = this
      vm.tableLoading = true
      let list = vm.filterAddress(vm.areaLists, address)
      const hasCity = list.some(item => item.id === (vm.selfAreaId.slice(0, 4) + '00'))
      const hasArea = list.some(item => item.id === vm.selfAreaId)
      if (hasCity) {
        list = list.filter(item => item.id === (vm.selfAreaId.slice(0, 4) + '00'))
      }
      if (hasArea) {
        list = list.filter(item => item.id === vm.selfAreaId)
      }
      vm.tableData = vm.translateTableData(vm.tableData, list, address.id)
      vm.tableLoading = false
    },
    check(type) {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.$refs[type].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })
    },
    refreshAddress() {
      const vm = this
      const params = {
        selfAreaId: vm.globaleSelfAreaId,
        userAreaId: vm.globaleSelfAreaId
      }
      // 用户区域范围拉取
      params.areaId = vm.globaleSelfAreaId
      store.dispatch('user/getUserArea2', params).then(() => {
        store.dispatch('user/setSideBarLoading', {
          value: false
        }).then(() => vm.noon)
      })
    },
    noon() {},
    // 添加区域 - 默认开放
    async handleAdd() {
      const vm = this
      await vm.check('formAdd')
      if (!vm.currItem || (vm.currItem && !vm.currItem.platformCode)) {
        vm.$message.warning('数据有误！')
        return
      }
      const data = {
        ...vm.formAdd,
        id: vm.formAdd.level[vm.formAdd.level.length - 1].slice(0, 4) + vm.formAdd.id,
        platformCode: vm.currItem.platformCode.slice(0, 6) + vm.formAdd.platformCode,
        level: 2, // 省=0,市=1,区=2,复合区=2
        parentId: vm.formAdd.level[vm.formAdd.level.length - 1],
        monitorOpen: 1, // 默认开放
        isOpen: 1,
        aggregation: 0 // 没有复合区的概念了
      }
      Api.addRegionalArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域添加成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        }).catch(err => {
          console.log('addRegionalArea', err)
        })
    },
    // 编辑区域 - 不改变是否开放
    async handleEdit () {
      const vm = this
      await vm.check('formAdd')
      const data = {
        ...vm.editData,
        id: vm.editData.id.slice(0, 4) + vm.formAdd.id,
        platformCode: vm.editData.platformCode.slice(0, 6) + vm.formAdd.platformCode,
        areaName: vm.formAdd.areaName,
        monitorOpen: vm.editData.monitorOpen ? 1 : 0,
        isOpen: vm.editData.isOpen ? 1 : 0
      }
      Api.editRegionalArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域修改保存成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        }).catch(err => {
          console.log('handleEdit', err)
        })
    },
    // 删除区域
    async handleDel() {
      const vm = this
      const data = {
        id: vm.editData.id
      }
      Api.deleteArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域移除成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        }).catch(err => {
          console.log('deleteArea', err)
        })
    },
    // 合并区域 - 默认开放
    async handleMergeArea() {
      const vm = this
      await vm.check('mergeArea')
      const data = {
        ...vm.mergeArea,
        level: 2, // 省=0,市=1,区=2,复合区=2
        parentId: vm.multipleSelection[0].parentId,
        monitorOpen: 1, // 默认开放
        isOpen: 1,
        aggregation: 1, // 没有复合区的概念了
        aggregationId: vm.multipleSelection.map(item => item.id).join(',')
      }
      Api.addRegionalArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('复合区合并成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('handleMergeArea', err)
        })
    },
    delAddressInLevel2(list) {
      return list.filter(node => node.level !== 2)
    },
    listToTree(list) {
      const info = list.reduce(
        (map, node) => {
          map[node.id] = node
          node.children = []
          return map
        }, {}
      )
      return list.filter(node => {
        info[node.parentId] && info[node.parentId].children.push(node)
        return !node.parentId
      })
    },
    treeToList(tree, result = []) {
      tree.forEach(node => {
        result.push(node)
        node.child && this.treeToList(node.child, result)
      })
      return result
    },
    changeAddress(list) {
      for (let i = 0, l = list.length; i < l; i++) {
        const item = list[i]
        if (item.children && item.children.length === 0) {
          delete item.children
        } else {
          this.changeAddress(item.children)
        }
      }
      return list
    },
    // 其他处理
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - H - 56 - 90
      })
    },
    // 对表格的默认操作
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'DisableSelection'
      }
    },
    selectable(row) {
      return row.aggregation === 0 && !row.aggregationId && row.level >= 2
    },
    getLevel(l) {
      return {
        0: '省份',
        1: '地级市',
        2: '区、县、复合区',
        3: '区、县、复合区',
        4: '区、县、复合区',
        5: '区、县、复合区',
        6: '区、县、复合区'
      }[String(l)]
    }
  },
  components: {
    WDialog
  }
}
</script>

<style lang="less" scoped>
.layout-header.regional-header {
  box-sizing: border-box;
  margin: 24px 16px;
  margin-top: 0;
}
.regional {
  .el-button-box .el-button+.el-button {
    margin-left: 0;
  }
  .regional_table {
    padding: 16px;
    box-sizing: border-box;
  }
  .btn-text {
    font-size: 14px;
    font-weight: 400;
  }
  .mr12 {
    margin-right: 12px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .el-table .DisableSelection .cell .el-checkbox__inner{
    display: none;
    position: relative;
  }
  .el-table .DisableSelection .cell:before{
    content: "";
    position: absolute;
  }
  .cell {
    cursor: pointer;
  }
  .w250 {
    width: 250px;
  }
  .tips {
    margin-left: 7px;
    color: #BBB;
    font-size: 14px;
  }
  .right {
    margin-right: 35px;
    text-align: right;
  }
  .fixed-bottom {
    width: 100%;
    height: 48px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1001;
    background-color: #FFF;
  }
  .flex-center {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #toolControl {
    margin: auto;
    z-index: 1001;
  }
  .toolItem {
    width: 30px;
    height: 30px;
    float: left;
    margin: 1px;
    padding: 4px;
    border-radius: 3px;
    background-size: 30px 30px;
    background-position: 4px 4px;
    background-repeat: no-repeat;
    box-shadow: 0 1px 2px 0 #E4E7EF;
    background-color: #ffffff;
    border: 1px solid #ffffff;
  }
  .toolItem:hover {
    border-color: #789CFF;
  }
  .active {
    border-color: #D5DFF2;
    background-color: #D5DFF2;
  }
  // 区域样式升级
  .nums {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 15px;
    color: #999;
    display: inline-block;
    font-size: 14px;
  }
  .el-input-45 input {
    padding-left: 45px;
    font-size: 14px;
  }
  .el-input-62 input {
    padding-left: 62px;
    font-size: 14px;
  }

  // 图例图标
  #draw {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/polygon.png');
  }
  #delete {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/delete.png');
  }
  #split {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/split.png');
  }
  #union {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/union.png');
  }

  .map_handle_box_device {
    position: absolute;
    border-radius: 5px;
    right: 31px;
    bottom: 88px;
    width: 124px;
    height: 118px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
    padding: 10px;

    .map_handles {
      margin-top: 10px;
      .map_handle {
        cursor: pointer;
        border-radius: 12px;
        border: 1px solid #1F8FFB;
        color: #1F8FFB;
        padding: 2px 5px;
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }

}
</style>
